import LivedigitalSDKError from './LivedigitalSDKError';

class TimeoutError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Request timed out';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? TimeoutError.DEFAULT_MESSAGE, errorCode ?? 'timeout', meta);
  }
}

export default TimeoutError;
